module.exports = __webpack_public_path__ + "assets/img/Cricket-Mentoring.bed536af.png";